import { FormModel } from '../../../../../components/Form';
import { Validators } from '../../../../../utils/validators';

export const AddEditTaxGroupForm = (strings: any, width = 4): FormModel[] => {
  const isFilter = width === 12;
  return [
    {
      label: strings.taxGroup_field_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'name',
      validators:
        width === 12
          ? []
          : [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 200 }],
      responsive: { xs: 12, sm: isFilter ? 12 : 6, md: width },
      required: width === 4,
    },
  ];
};

export const TAX_SCOPE_OPTIONS = (strings: any) => [
  { label: strings.taxGroup_scope_same_state, value: 'SAME_REGION' },
  { label: strings.taxGroup_scope_different_state, value: 'DIFFERENT_REGION' },
  { label: strings.taxGroup_scope_always, value: 'ALWAYS' },
];
